import { render, staticRenderFns } from "./first-screen.vue?vue&type=template&id=06f6c3f6&scoped=true&"
import script from "./first-screen.vue?vue&type=script&lang=js&"
export * from "./first-screen.vue?vue&type=script&lang=js&"
import style0 from "./first-screen.vue?vue&type=style&index=0&id=06f6c3f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f6c3f6",
  null
  
)

export default component.exports